// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QNoiF","left":"styles_left__2BkBe"};